import { useState } from "react";
import { PlatformSite } from "@/components/platform/settings/PlatformSite";
import { PlatformChip } from "@/components/platform/settings/PlatformChip";
import { PlatformRecaptcha } from "@/components/platform/settings/PlatformRecaptcha";
import { PlatformResend } from "@/components/platform/settings/PlatformResend";
import { EmailSettings } from "@/components/platform/settings/EmailSettings";
import { PlatformMaps } from "@/components/platform/settings/PlatformMaps";

const TABS = [["site", "Site"], ["chip", "CHIP"], ["resend", "Resend"], ["recaptcha", "reCAPTCHA"], ["maps", "Google Maps"]];
const FORMS = [["login", "Player sign-in"], ["register", "Player sign-up"], ["forgot", "Forgot password"]];

export function SettingsAdmin({ view }) {
  const [tab, setT] = useState("site");
  const t = view || tab;
  return (
    <div data-testid="platform-settings">
      {!view && <div className="mb-6 flex flex-wrap gap-2">{TABS.map(([k, l]) => <button key={k} onClick={() => setT(k)} data-testid={`platform-settings-tab-${k}`} className={`rounded-lg px-3 py-1.5 text-xs font-semibold ${t === k ? "bg-slate-100 text-slate-900" : "bg-slate-800 text-slate-300 hover:text-white"}`}>{l}</button>)}</div>}
      {t === "site" && <PlatformSite />}
      {t === "chip" && <PlatformChip path="/asv/admin/settings/chip" platform />}
      {t === "resend" && <PlatformResend />}
      {t === "email" && <EmailSettings />}
      {t === "recaptcha" && <PlatformRecaptcha path="/asv/admin/settings/recaptcha" domain="allsportsvenues.com" forms={FORMS} />}
      {t === "maps" && <PlatformMaps />}
    </div>
  );
}
